import CurrencyConverter from "./components/CurrencyConverter/CurrencyConverter";

const App = () => {
  return <CurrencyConverter />;
};

export default App;
